import { cn } from "@/lib/cn";

export function VoiceGradientReflection({
  className,
  testId = "voice-glass-reflection",
}: {
  className?: string;
  testId?: string;
}) {
  return (
    <span
      data-testid={testId}
      className={cn(
        "pointer-events-none absolute -inset-x-12 -inset-y-8",
        className,
      )}
      style={{
        opacity: "var(--voice-glass-volume)",
        background:
          "linear-gradient(108deg, transparent 0%, var(--voice-glass-b) 24%, rgba(255,255,255,0.68) 43%, var(--voice-glass-a) 55%, var(--voice-glass-c) 70%, transparent 92%)",
        animation:
          "denker-voice-glass-reflect var(--voice-glass-speed) ease-in-out infinite",
      }}
    />
  );
}
